import { faArrowRight, faBook, faCheck, faEnvelope, faExclamation, faPen, faRefresh, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR/";
import { maskUC } from "../../infra/utils/maskUC";
import { useSelector } from "react-redux";

const StatusVistoria = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Em digitação" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </Tooltip>
            )
        case 1:
            return (
                <Tooltip title="Aguardando análise" placement="right">
                    <div className="status_pendente">
                        <FontAwesomeIcon icon={faRefresh} />
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Revisar solicitação" placement="right">
                    <div className="status_revisao">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            )
        case 3:
            return (
                <Tooltip title="Agendamento solicitado" placement="right">
                    <div className="status_favoravel_com_restricoes">
                        <FontAwesomeIcon icon={faBook} />
                    </div>
                </Tooltip>
            )
        case 4:
            return (
                <Tooltip title="Vistoria solicitada" placement="right">
                    <div className="status_favoravel_com_restricoes">
                        <FontAwesomeIcon icon={faBook} />
                    </div>
                </Tooltip>
            )
        case 6:
            return (
                <Tooltip title="Arquivada" placement="right">
                    <div className="status_arquivada">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Concluído" placement="right">
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            )
    }
}

const StatusAgendamento = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <p>Solicitação não iniciada no CRM</p>
            )
        case 1:
            return (
                <p>Aguardando agendamento</p>
            )
        case 2:
            return (
                <p>Vistoria em andamento</p>
            )
        case 3:
            return (
                <p>Vistoria aprovado</p>
            )
        case 4:
            return (
                <p>Vistoria reprovada</p>
            )
        default:
            return (
                <p>Não realiza serviço</p>
            )
    }
}

const StatusObra = ({ value }) => {
    switch (value) {
        case 1:
            return (
                <Tooltip title="Sem necessidade de obra" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faX} />
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Aguardando geração de obra" placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            )
        case 3:
            return (
                <Tooltip title="Obra em andamento" placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Obra energizada" placement="right">
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            )
    }
}

const RendererUnidadeConsumidora = ({ value }) => {
    const uc = useSelector(state => state.uc);

    if (!value) {
        return (
            <Tooltip
                title={
                    <span>
                        Orçamento de conexão com ligação nova.
                        <br />
                        (UC não informada)
                    </span>
                }
                placement="top"
            >
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faX} />
                </div>
            </Tooltip>
        );
    }

    const valorFormatado = uc?.rn1095
        ? maskUC(String(value))
        : value;

    return (
        <Tooltip title={valorFormatado} placement="bottom">
            <span>{valorFormatado}</span>
        </Tooltip>
    );
};

const columnsSolicitacaoVistoria = [
    {
        field: 'Situacao', headerName: 'Situação',
        renderCell: (params) => (
            <StatusVistoria value={params.value} />
        )
    },
    {
        field: 'id', headerName: 'Solic. vistoria', flex: 0.37,
    },
    {
        field: 'CodigoSolicitacaoAcesso', headerName: 'Orç. conexão', flex: 0.37,
    },
    {
        field: 'SolicitacaoDeAcesso.Nome', headerName: 'Nome', flex: 0.8,
        renderCell: (params) => (
            <Tooltip title={params?.row?.SolicitacaoDeAcesso?.Nome} placement="bottom">
                <p>{params?.row?.SolicitacaoDeAcesso?.Nome}</p>
            </Tooltip>
        )
    },
    {
        field: 'SolicitacaoDeAcesso.CodigoUC', headerName: 'UC', flex: 0.4,
        renderCell: (params) => (
            <RendererUnidadeConsumidora value={params?.row?.SolicitacaoDeAcesso?.CodigoUC} />
        )
    },
    {
        field: 'Protocolo', headerName: 'Protocolo', flex: 0.4
    },
    {
        field: 'DataCadastro', headerName: 'Data de cadastro', flex: 0.425,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada;
        }
    },
    {
        field: 'PrazoAnalise', headerName: 'Prazo de análise', flex: 0.425,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return (dataFormatada.includes("01/01/1900") || dataFormatada.includes("01/01/0001")) ? '' : dataFormatada;
        }
    },
    {
        field: 'SituacaoAgendamento', headerName: 'Situação agendamento/vistoria', flex: 0.75,
        renderCell: (params) => (
            <StatusAgendamento value={params.value} />
        )
    },
    {
        field: 'SolicitacaoDeAcesso.SituacaoObra', headerName: 'Situação obra',
        renderCell: (params) => {
            let situacaoObra = params?.row?.SolicitacaoDeAcesso ? params?.row?.SolicitacaoDeAcesso?.SituacaoObra : 1;

            return <StatusObra value={situacaoObra} />;
        }
    },
    {
        field: 'Observacao', headerName: 'Observação', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
]

export { columnsSolicitacaoVistoria }